import "./index.scss";

import { Box } from "@mui/material";

import DefinedProgramContainer from "../../components/DefinedProgramContainer";

const CardioDefinedProgram = ({ headerInfo }) => {
  const activities = headerInfo.exercises.filter((f) => f.type === "ACTIVITIES");
  const machinesConnectedToFitlinxx = headerInfo.exercises.filter(
    (f) => f.type === "MACHINES_CONNECTED_TO_FITLINXX"
  );
  const machinesNotConnectedToFitlinxx = headerInfo.exercises.filter(
    (f) => f.type === "MACHINES_NOT_CONNECTED_TO_FITLINXX"
  );
  const classes = headerInfo.exercises.filter((f) => f.type === "CLASSES");

  return (
    <Box className="cardio-defined-program">
      <DefinedProgramContainer headerInfo={headerInfo}>
        {activities?.length > 0 && (
          <Box className="cardio-defined-program__accordion-body">
            <p className="section-title">Activities</p>
            {activities.map((m, i) => (
              <CardioItem key={`activityExercise${i}`} label1={m.name} label2={`${m.time} min`} />
            ))}
          </Box>
        )}

        {machinesConnectedToFitlinxx?.length > 0 && (
          <Box className="cardio-defined-program__accordion-body">
            <p className="section-title">Machines connected to FitLinxx</p>
            {machinesConnectedToFitlinxx.map((m, i) => (
              <CardioItem key={`mcftlxExercise${i}`} label1={m.name} label2={`${m.time} min`} />
            ))}
          </Box>
        )}

        {machinesNotConnectedToFitlinxx?.length > 0 && (
          <Box className="cardio-defined-program__accordion-body">
            <p className="section-title">Machines Not connected to FitLinxx</p>
            {machinesNotConnectedToFitlinxx.map((m, i) => (
              <CardioItem key={`mncftlxExercise${i}`} label1={m.name} label2={`${m.time} min`} />
            ))}
          </Box>
        )}

        {classes?.length > 0 && (
          <Box className="cardio-defined-program__accordion-body">
            <p className="section-title">Classes</p>
            {classes.map((m, i) => (
              <CardioItem key={`classExercise${i}`} label1={m.name} label2={`${m.time} min`} />
            ))}
          </Box>
        )}
      </DefinedProgramContainer>
    </Box>
  );
};

const CardioItem = ({ label1, label2 }) => {
  return (
    <Box className="cardio-program-item">
      <p>{label1}</p>
      <label>{label2}</label>
    </Box>
  );
};

export default CardioDefinedProgram;
